import { Component, Input, ChangeDetectorRef, isDevMode, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PhoneService } from '@wephone-app-phone/services/phone/phone.service';
import { PhoneCall } from '@wephone-app-phone/services/phone/phonecall';
import { CallQueueEntity } from '@wephone-core/model/entity/callqueue';
import { DialogService, Platform, PhoneNumberService, parseDateTime } from '@wephone-utils';
import { FlexIvrSettings, EntityManager, ConfigManager } from '@wephone-core/wephone-core.module';
import { CallTransferModal } from '@wephone-app-phone/modals/call-transfer/call-transfer';
import { IUserEntity } from '@wephone-core/model/entity/user.i';
import { FlexBaseComponent } from '@wephone-core-ui';
import { StorageService } from '@wephone-core/service/storage.service';
import { QualificationService } from '@wephone-common';
import { RecordingTempFile } from 'jsphonelib/recording-temp-file';
import { CallCampaignRescheduleModal } from '@wephone-app-phone/modals/call-campaign-reschedule/call-campaign-reschedule';
import { AgentPanelService } from '@wephone/services/agent-panel.service';
import { _tk, _ti } from '@wephone-translation';
// import { AudioDeviceService } from '@wephone-app-phone/services/audio-devices.service';
import { UserEntity } from '@wephone-core/model/entity/user';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { ISentSmsModalData, SentSmsModalComponent } from '@wephone-sms/component';
import { DidEntity } from '@wephone-core/model/entity/did';
import { DidRepository } from '@wephone-core/model/repository/did';
import { SmsService } from '@wephone-sms/service/sms.service';
import { DateTime } from 'luxon';
import { EnterpriseParamDict, FeatureName } from '@wephone-core/system';
import * as _ from 'lodash';
import * as Sentry from "@sentry/browser";
import { ActiveCallInfo } from '@wephone-app-phone/services';
import { CallTransferType } from '@wephone-core/model/entity/liveusercall.i';
import { TransferDestinationType, TransferRequest } from '@wephone-core/core/call_transfer';

@Component({
  selector: 'call-active',
  templateUrl: 'call-active.html',
  styleUrls: ['./call-active.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('keypad', [
      state(
        'visible',
        style({
          opacity: 1,
          display: 'block'
        })
      ),
      state(
        'invisible',
        style({
          opacity: 0,
          display: 'none'
        })
      ),
      transition('visible => invisible', animate('0s')),
      transition('invisible => visible', animate('0.5s'))
    ]),
    trigger('buttons', [
      state(
        'visible',
        style({
          opacity: 1,
          display: 'block'
        })
      ),
      state(
        'invisible',
        style({
          opacity: 0,
          display: 'none'
        })
      ),
      transition('visible => invisible', animate('0s')),
      transition('invisible => visible', animate('0.5s'))
    ])
  ]
})
export class CallActiveComponent extends FlexBaseComponent implements OnInit {
  @Input() public call: PhoneCall;

  session_info: any;
  queue: CallQueueEntity;
  keypadVisible = false;
  vocalCommandUrl = false;
  isDevMode = isDevMode;
  callData: ActiveCallInfo;
  currentUser: UserEntity;
  inIFrame: boolean;
  enterpriseParams: EnterpriseParamDict;
  hasFeatureGroup: boolean = ConfigManager.getInstance().hasFeature(FeatureName.SERVICE_GROUP);
  isSMSFeaturedEnabled: boolean = ConfigManager.getInstance().hasFeature(FeatureName.SMS);
  readonly CallTransferType = CallTransferType;

  private _didsSendSMS: { [key: string]: DidEntity } = {};
  private _defaultDidSendSMS: DidEntity;
  private transferOutData: TransferRequest;

  constructor(
    public phoneService: PhoneService,
    private dialogService: DialogService,
    private settings: FlexIvrSettings,
    storage: StorageService,
    cdr: ChangeDetectorRef,
    private readonly qualificationService: QualificationService,
    // private audioDeviceService: AudioDeviceService,
    private agentPanelService: AgentPanelService,
    // em: EntityManager,
    authService: AuthenticationService,
    private phonenumberService: PhoneNumberService,
    private smsService: SmsService,
    platform: Platform,
    private configService: ConfigManager
  ) {
    super(cdr);
    this.inIFrame = window['GRAAM_IN_IFRAME'];
    this.currentUser = authService.getUser();
    storage.getAppConfig('vocal_command_url').then(
      val => {
        this.vocalCommandUrl = val;
      }
    );
    this.enterpriseParams = this.configService.getEnterpriseParams();
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    await this.setDefaultDidSendSms();

    if (this.call.isInbound()) {
      this.getActiveCallInfo();
    } else {
      const t = setTimeout(this.getActiveCallInfo, 3000);
      this.call.watchHangup(
        c => {
          clearTimeout(t);
        }
      );
    }
  }

  private getActiveCallInfo = async (): Promise<void> => {
    // this.loggerService.log('getActiveCallInfo process', DateTime.local().toFormat('hh:mm:ss'));
    // const response: ActiveCallInfo = await this.phoneService.getActiveCallInfo();
    if (!this.call.sipCallId) {
      this.loggerService.error('No active sip call id');
      return;
    }

    const response: ActiveCallInfo = await this.phoneService.getActiveCallInfoById(this.call.sipCallId);
    // this.loggerService.log('GetActiveCallInfo response', response, DateTime.local().toFormat('hh:mm:ss'));
    if (response) {
      if (this.call) {
        this.call.extraInfo = response;
      }

      this.callData = response;
      await this.setDidSendSMS();
    }
  }

  get didSendSMS(): DidEntity {
    const localNumber: string = this.call && this.call.localNumber;
    if (this._didsSendSMS.hasOwnProperty(localNumber)) {
      return this._didsSendSMS[localNumber];
    }

    return this._defaultDidSendSMS;
  }

  private async setDidSendSMS(): Promise<void> {
    const localNumber: string = this.call && this.call.localNumber;
    // this.loggerService.log('localNumber', localNumber);
    if (localNumber) {
      if (this._didsSendSMS.hasOwnProperty(localNumber)) {
        return;
      }

      const repo: DidRepository = EntityManager.getRepository('DidRepository') as DidRepository;
      // const did: DidEntity = repo.getDidByNumber(localNumber);
      const dids = await repo.loadObjectList();
      for (const did of dids) {
        if (did && did.can_send_sms) {
          this._didsSendSMS[did.number] = did;
        }
      }
    }

    if (!this.currentUser) {
      this.loggerService.error('No logged user');
      return;
    }
  }

  private async setDefaultDidSendSms(): Promise<void> {
    if (this._defaultDidSendSMS) {
      return;
    }

    try {
      this._defaultDidSendSMS = await this.smsService.getDidForReplySMS(this.currentUser);
    } catch (e) {
      this.loggerService.error('Get did for reply SMS failure', e);
    }
  }

  sendSMS(): void {
    if (!this.isSMSFeaturedEnabled) {
      this.loggerService.error('Do not support SMS feature');
      return;
    }

    // if (!this.didSendSMS) {
    //   this.loggerService.error('No did for sending SMS');
    //   return;
    // }

    const data: ISentSmsModalData = {
      destination: this.phonenumberService.getDisplayNumber(this.call.remoteNumber),
      // caller: this.didSendSMS.number
      caller: undefined
    };

    this.dialogService.openDialog2(SentSmsModalComponent, {
      width: '80%',
      data,
      padding: true
    });
  }

  endCall(): void {
    this.call.hangup();
    // this.detectChanges();
  }

  answerCall(): void {
    if (this.call.canAnswerHere()) {
      this.call.answer();
    } else if (this.inIFrame) {
      Sentry.withScope(scope => {
        scope.setExtra("remote_number", this.call.remoteNumber);
        scope.setExtra("local_number", this.call.localNumber);
        scope.setExtra("has_sipcall", this.call.hasSipCall());
        scope.setExtra("sip_call_id", this.call.sipCallId);
        scope.setExtra("sip_stack_enabled", this.phoneService.isSipStackEnabled());
        scope.setExtra("phone_mode", this.agentPanelService.getMyCallcenterStatus().phone_mode);
        Sentry.captureMessage("Unable to answer call");
      });
      window.open(`tel:anwser`);
    }
    // this.detectChanges();
  }

  hasAnsweredElsewhere(): boolean {
    return this.call && this.call.isAnswered() && !this.call.hasSipCall();
  }

  unableToAnswer(): boolean {
    if (this.call && !this.call.isAnswered()) {
      if (this.agentPanelService.getMyCallcenterStatus().phone_mode !== 1) {
        if (this.phoneService.isSipStackEnabled()) {
          const hasNoSipCall = !this.call.hasSipCall();

          if (hasNoSipCall) {
            this.loggerService.error('Unabled to answer, no sip call', this.call);
          }

          return hasNoSipCall;
        }
        // this.loggerService.error('Unabled to answer, sip stack not enabled', this.call);
      }
      // this.loggerService.error('Unabled to answer, phone mode != 0', this.call);
    }

    // this.loggerService.error('Unabled to answer', this.call);
    return false;
  }

  uimodeEnterprise(): boolean {
    return this.settings.btEnterprise();
  }

  uimodeHotel(): boolean {
    return this.settings.btHotel();
  }

  uimodeCallCenter(): boolean {
    return this.settings.btCallCenter();
  }

  transferCall(): void {
    const numbers =
      this.session_info && this.session_info.callqueue ? this.session_info.callqueue.transfer_numbers : [];

    const data = {
      type: 'call_transfer',
      predefined_numbers: numbers
    };

    this.dialogService.openDialog2(CallTransferModal, { width: '80%', data, padding: false }, transferRequest => {
      if (transferRequest) {
        this.phoneService.transferCall(this.call, transferRequest);
        this.transferOutData = transferRequest;
        // this.detectChanges();
      }
    });
  }

  confirmTransfer(): void {
    this.phoneService.confirmTransfer(this.call);
    // this.detectChanges();
  }

  cancelTransfer(): void {
    this.phoneService.cancelTransfer(this.call);
    // this.detectChanges();
  }

  toggleHold(): void {
    this.phoneService.setOnhold(this.call, !this.call.isOnhold());
    // this.detectChanges();
  }

  toggleRecording(): void {
    this.phoneService.setRecordingState(this.call, !this.call.isRecording(), false);
    // this.detectChanges();
  }

  toggleMute(): void {
    this.call.toggleMute();
    // this.detectChanges();
  }

  canRecord(): boolean {
    return this.call.hasCallData() && (this.call.queue && this.call.queue.has_recording || !!this.call.user);
  }

  canQualify(): boolean {
    if (!this.call.queue || !this.call.queue.has_qualification) {
      return false;
    }

    if (this.call.isInbound() && !this.call.queue.in_qualification_id) {
      return false;
    }

    if (!this.call.isInbound() && !this.call.queue.out_qualification_id) {
      return false;
    }

    return true;
  }

  get clientName(): string {
    if (this.callData && this.callData.details && this.callData.details.client_name) {
      return this.callData.details.client_name;
    }
    if (this.call.calldata && this.call.calldata.client_name) {
      return this.call.calldata.client_name;
    }
  }

  get queueName(): string {
    if (this.call.queue) {
      return this.call.queue.queue_name;
    }
  }

  get groupName(): string {
    if (this.call.group) {
      return this.call.group.name;
    }
  }

  get user(): IUserEntity {
    if (this.call.sipphone && this.call.sipphone.user) {
      return this.call.sipphone.user;
    }
  }

  get isCampaign(): boolean {
    return this.callData && this.callData.data_type === 'campaign';
  }

  get transferOutUser(): UserEntity {
    return this.transferOutData && this.transferOutData.destination_type === TransferDestinationType.USER && this.transferOutData.destination as UserEntity || undefined;
  }

  get transferOutDestination(): string {
    if (this.transferOutData && this.transferOutData.destination) {
      if (this.transferOutData.destination_type === TransferDestinationType.USER) {
        return this.transferOutData.destination.name;
      }
      if (this.transferOutData.destination_type === TransferDestinationType.NUMBER) {
        return this.transferOutData.destination;
      }
    }
    return '';
  }

  get transferOutReason(): string {
    return this.transferOutData && this.transferOutData.transfer_reason || '';
  }

  hasTransferOut(): boolean {
    return this.call.isTransfering() && !!this.transferOutData;
  }

  hasTransferIn(): boolean {
    return this.call && !this.call.isTransfering() && (this.call.transferInUser || this.call.transferReason) ? true : false;
  }

  doQualify(): void {
    if (this.canQualify()) {
      this.qualificationService.openQualification(this.call);
    }
  }

  // terminateSchedule(): Promise<any> {
  //   return this.dialogService.confirmDialog(
  //     _ti('dialogs.confirmation'),
  //     _ti('campaign.message.confirm_terminate'),
  //     async () => {
  //       try {
  //         const res = await this.agentPanelService.outcallJobTerminate(
  //           this.callData.details.campaign_id, this.callData.details.id);

  //         // Manually update call data
  //         this.callData.details.finished = 1;

  //         this.toastService.show(_ti('public.message.update_success'));
  //       } catch (e) {
  //         const msg: string = e && e.error && e.error.message ? e.error.message : _ti('public.message.update_success');
  //         this.toastService.showError(msg);
  //       }
  //     }
  //   );
  // }

  reschedule(): void {
    this.dialogService.openDialog2(CallCampaignRescheduleModal, {
      width: '80%', data: {
        hour_start: this.callData.details.hour_start,
        scheduled_dt: this.callData.details.scheduled_dt
      }
    }, async (result: { dateTime: DateTime }) => {
      if (!result) {
        return;
      }

      try {
        const res: any = await this.agentPanelService.outcallJobReschedule(
          this.callData.details.campaign_id, this.callData.details.id, result.dateTime);

        // Manually update call data
        const scheduleDt: string = result.dateTime.toFormat('yyyy-MM-dd');
        const hourStart: string = result.dateTime.toFormat('HH:mm:00');
        this.callData.details.hour_start = hourStart;
        this.callData.details.scheduled_dt = scheduleDt;
        this.callData.details.finished = 0;

        this.toastService.show(_ti('public.message.update_success'));
      } catch (e) {
        const msg: string = e && e.error && e.error.message ? e.error.message : _ti('public.message.update_success');
        this.toastService.showError(msg);
      }
    });
  }

  async openContactProfile(): Promise<void> {
    const url = await this.call.getCrmContactUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }

  isRecordingVocalCommand(): boolean {
    return this.phoneService.isRecordingVoiceCommand();
  }

  async startRecordingVocalCommand(): Promise<void> {
    const recordingFile: RecordingTempFile = await this.phoneService.startRecordingVocalCommand();
    if (recordingFile) {
      recordingFile.onRecordingStop().then(
        filePath => {
          this.phoneService.sendVocalCommandData();
        }
      );
    }

  }

  stopRecordingVocalCommand(): void {
    this.phoneService.stopRecordingVocalCommand();
  }

  // changeVolumn(): void {
  //   this.audioDeviceService.openAudioDeviceSettings();
  // }

  addParticipant(): void {
    this.dialogService.openDialog3(
      'call_active.add_participant_hint',
      CallTransferModal,
      { width: '80%', data: { type: 'add_participant' }, padding: false },
      transferRequest => {
        if (transferRequest) {
          this.phoneService.conferenceAddLeg(this.call, transferRequest);
        }
      });
  }

  removeParticipant(): void {
    this.dialogService.confirmDialog(
      _ti('dialogs.confirmation'),
      _ti('call_active.confirm_remove_participant_msg'),
      () => {
        this.phoneService.conferenceRemoveLeg(this.call);
      }

    );
  }

  get thirdCallData(): { start_dt?: DateTime, remote_number?: string, remote_name?: string, is_outbound?: number } {
    const callData = this.call && this.call.calldata;
    if (!callData || _.isEmpty(callData.third_call_data)) {
      return undefined;
    }

    const thirdCallData: { start_dt?: DateTime, remote_number?: string, remote_name?: string, is_outbound?: number } = {
      start_dt: callData.third_call_data.start_dt ? parseDateTime(callData.third_call_data.start_dt) : undefined,
      remote_number: callData.third_call_data.remote_number,
      remote_name: callData.third_call_data.remote_name,
      is_outbound: callData.third_call_data.is_outbound
    };
    return thirdCallData;
  }
}
